/* eslint-disable */
<template>
  <!-- About us -->
  <div class="section-2 abouut">
    <div class="container-fluid">
      <div class="d-flex justify-content-center">
        <div class="d-flex flex-column m-4">
          <h1 class="heading-1">
            About - <span class="orange">MB</span> Clothing
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutBanner"
};
</script>

<style></style>
